<template>
  <div>
    <div v-if="store.isLeaderboardLoading" class="py-12 space-y-3">
      <div v-for="i in 5" :key="i" class="flex items-center gap-4 px-6 animate-pulse">
        <div class="w-8 h-8 rounded-full bg-gray-100" />
        <div class="flex-1 h-5 bg-gray-100 rounded" />
        <div class="w-20 h-5 bg-gray-100 rounded" />
      </div>
    </div>

    <div v-else-if="!store.leaderboard.length" class="py-16 text-center">
      <Trophy class="mx-auto h-10 w-10 text-gray-300" />
      <p class="mt-3 text-sm text-gray-500">No leaderboard data yet.</p>
    </div>

    <div v-else>
      <div
        v-for="(entry, index) in store.leaderboard"
        :key="entry.id"
        class="group flex items-center gap-4 px-6 py-3 transition-colors"
        :class="[
          isCurrentUser(entry.name) ? 'bg-lime-50 hover:bg-lime-100' : 'hover:bg-gray-50',
          { 'border-b border-gray-100': index < store.leaderboard.length - 1 }
        ]"
      >
        <div
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold"
          :class="rankClasses(index)"
        >
          <Trophy v-if="index < 3" class="h-3.5 w-3.5" />
          <span v-else>{{ index + 1 }}</span>
        </div>

        <div class="min-w-0 flex-1">
          <p class="truncate text-sm font-medium text-gray-900">
            {{ entry.name }}
            <span v-if="isCurrentUser(entry.name)" class="text-xs font-normal text-lime-700">(you)</span>
          </p>
          <p class="truncate text-xs text-gray-500">
            {{ entry.employers_details.map((e) => e.name).join(', ') || '' }}
          </p>
        </div>

        <div class="flex items-center text-right shrink-0 flex-col">
            <p class="text-sm font-semibold text-emerald-600">{{ entry.successful_referrals }}</p>
            <p class="text-[10px] uppercase tracking-wider text-gray-400">Confirmed</p>
        </div>
      </div>

      
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { Trophy } from 'lucide-vue-next'
import { useMyReferralsStore } from '@/stores/myReferrals'
import { useUserStore } from '@/stores/user'

const store = useMyReferralsStore()
const userStore = useUserStore()

const currentUserName = computed(() => {
  const u = userStore.currentUser
  return u ? `${u.first_name} ${u.last_name}`.trim().toLowerCase() : ''
})

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  store.fetchLeaderboard()
})

function isCurrentUser(name: string) {
  return currentUserName.value !== '' && name.trim().toLowerCase() === currentUserName.value
}

function rankClasses(index: number) {
  switch (index) {
    case 0:
      return 'bg-amber-100 text-amber-700'
    case 1:
      return 'bg-gray-200 text-gray-600'
    case 2:
      return 'bg-orange-100 text-orange-600'
    default:
      return 'bg-gray-100 text-gray-500'
  }
}
</script>

